// Общий wrapPageElement для gatsby-browser.js и gatsby-ssr.js.
// Должен быть ОДИНАКОВЫМ на сервере и в браузере, иначе будет hydration mismatch.
import React from 'react';
import AppShell from './src/components/AppShell';
import CookieNotice from './src/components/CookieNotice';

// Маршруты «приложения», у которых должно быть боковое меню. Лендинг, логин,
// регистрация, сброс пароля и 404 остаются БЕЗ сайдбара (как сейчас).
const APP_ROUTE_PREFIXES = [
  '/ai-photo',
  '/profile',
  '/billing',
  '/history',
  '/settings'
];

const hasSidebar = (pathname) => {
  if (!pathname) return false;
  return APP_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/') || pathname.startsWith(prefix)
  );
};

export const wrapPageElement = ({ element, props }) => {
  const pathname = props?.location?.pathname || props?.path || '';
  if (!hasSidebar(pathname)) {
    return <>{element}<CookieNotice /></>;
  }
  return <><AppShell location={props?.location}>{element}</AppShell><CookieNotice /></>;
};
